import"react/jsx-runtime";import{styled as r,Skeleton as i}from"@mui/material";r(i)((function(r){return{margin:r.theme.spacing(1,0)}}));
//# sourceMappingURL=Loader.js.map
